/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_link_microsoft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Microsoft`)
};

const zh_hans1_settings_link_microsoft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绑定 Microsoft`)
};

const zh_hant1_settings_link_microsoft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`綁定 Microsoft`)
};

const fr_settings_link_microsoft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lier Microsoft`)
};

const de_settings_link_microsoft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft verknüpfen`)
};

const ja_settings_link_microsoft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft を連携`)
};

const ko_settings_link_microsoft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft 연결`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_link_microsoft = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_link_microsoft(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_link_microsoft", locale)
	if (locale === "en") return en_settings_link_microsoft(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_link_microsoft(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_link_microsoft(inputs)
	if (locale === "fr") return fr_settings_link_microsoft(inputs)
	if (locale === "de") return de_settings_link_microsoft(inputs)
	if (locale === "ja") return ja_settings_link_microsoft(inputs)
	return ko_settings_link_microsoft(inputs)
};